// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ea03f33","453":"66c6b471","455":"9082af04","977":"7869a5e3"}[chunkId] + ".chunk.js";
};